import { TinyColor } from "@ctrl/tinycolor";
import { Area, AreaChart, ResponsiveContainer } from "recharts";

export type TrendSparklineProps = {
  data: number[];
  color: string;
  height: number;
};

export const TrendSparkline: React.FC<TrendSparklineProps> = ({
  data,
  color,
  height,
}) => {
  if (data.length === 0) return null;
  const chartData = data.map((value, index) => ({ index, value }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart
        data={chartData}
        margin={{ top: 4, right: 4, bottom: 4, left: 4 }}
      >
        <Area
          dataKey="value"
          stroke={color}
          fill={new TinyColor(color).lighten(30).desaturate(30).toHexString()}
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
          type="monotone"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
